import * as React from 'react';
import { MemberPageWrapper } from './MemberPageWrapper';
import { PageGuideDefinition } from '../../designSystem/PageGuide';
import { PageTopBarBreadcrumb } from './wrapperLayouts/elements/topBar/TopBar';

type UserPageWrapperProps = {
    children: React.ReactNode,
    breadCrumbs?:PageTopBarBreadcrumb[],
    guide?:PageGuideDefinition
}

export const UserPageWrapper: React.FunctionComponent<UserPageWrapperProps> = (props:UserPageWrapperProps) => 
    <MemberPageWrapper allowUser={true} selectedMenuItemKey={undefined} breadCrumbs={props.breadCrumbs} guide={props.guide}>
        {props.children}
    </MemberPageWrapper>